import { useQuery } from '@tanstack/react-query'
import { fetchPropertyById } from 'utility/queries/property'

export const useManyProperties = (propertyIds, disabled) =>
  useQuery({
    enabled: propertyIds && propertyIds.length && !disabled ? true : false,
    queryKey: ['properties', ...propertyIds],
    queryFn: async () =>
      await Promise.all(
        propertyIds.map(async (_propertyId) => {
          return await fetchPropertyById({ id: _propertyId })
        }),
      ),
    retry: 3,
  })
